import { getPattern, getPatterns } from "@/lib/catalog";

// Famílias de tecidos. A família escolhida no painel (campo "family" do padrão) tem prioridade;
// quando não há, usa-se o identificador. Usadas no seletor da peça, na loja e na seleção da homepage.
export const FAMILIES = [
  ["Flores", /^(folhas|florzinhas|flores|petalas)/], ["Vichy", /^vichy/], ["Riscas", /^riscas/],
  ["Musselina e bordados", /^(musselina|bordado|fio-|margaridas)/], ["Waffle", /^waffle/], ["Impermeáveis", /^imp-/], ["Saquinhos", /^(algodao|forro)/],
];

export const familyOf = (id) => getPattern(id)?.family || (FAMILIES.find(([, re]) => re.test(id))?.[0] ?? "Outros");

// Nomes das famílias em uso: as de base primeiro, depois as criadas no painel, e "Outros" no fim.
export const familyNames = (ids = getPatterns().map((p) => p.id)) => {
  const used = new Set(ids.map(familyOf));
  const base = FAMILIES.map(([n]) => n);
  const extra = [...used].filter((n) => n !== "Outros" && !base.includes(n)).sort((a, b) => a.localeCompare(b, "pt"));
  return [...base, ...extra, "Outros"].filter((n) => used.has(n));
};

// Um tecido por família (o primeiro), para mostrar variedade em pouco espaço.
export const diversePicks = (patterns, max = 8) => {
  const seen = new Set();
  const picks = patterns.filter((p) => {
    const f = familyOf(p.id);
    if (seen.has(f)) return false;
    seen.add(f);
    return true;
  });
  const rest = patterns.filter((p) => !picks.includes(p));
  return [...picks, ...rest].slice(0, max);
};
